import Vue from "vue";
import UtilityService from "../services/UtilityService";

Vue.directive("uppercase", {
  update: function(el) {
    el.value = el.value.toUpperCase();
  }
});

Vue.directive("address", {
  update: function(el) {
    if (el.value) {
      var event = new Event("input", { bubbles: true });
      el.value = UtilityService.sanitizeAddressString(el.value);
      el.dispatchEvent(event);
    }
  }
});
